// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
// must use the same indexes as:
// https://github.com/weave-lab/monorail/blob/main/shared/protorepo/enums/data/locationvertical.proto
export var Vertical;
(function (Vertical) {
    Vertical["INVALID_VERTICAL"] = "INVALID_VERTICAL";
    Vertical["DENTAL"] = "DENTAL";
    Vertical["OPTOMETRY"] = "OPTOMETRY";
    Vertical["WELLNESS"] = "WELLNESS";
    Vertical["OTHER"] = "OTHER";
    Vertical["VET"] = "VET";
    Vertical["ORTHODONTIC"] = "ORTHODONTIC";
    Vertical["HOMESERVICE"] = "HOMESERVICE";
})(Vertical || (Vertical = {}));
export var Vertical_index;
(function (Vertical_index) {
    Vertical_index[Vertical_index["INVALID_VERTICAL"] = 0] = "INVALID_VERTICAL";
    Vertical_index[Vertical_index["DENTAL"] = 1] = "DENTAL";
    Vertical_index[Vertical_index["OPTOMETRY"] = 2] = "OPTOMETRY";
    Vertical_index[Vertical_index["WELLNESS"] = 3] = "WELLNESS";
    Vertical_index[Vertical_index["OTHER"] = 4] = "OTHER";
    Vertical_index[Vertical_index["VET"] = 5] = "VET";
    Vertical_index[Vertical_index["ORTHODONTIC"] = 6] = "ORTHODONTIC";
    Vertical_index[Vertical_index["HOMESERVICE"] = 7] = "HOMESERVICE";
})(Vertical_index || (Vertical_index = {}));
